module.exports = __webpack_public_path__ + "img/kwyy.a85b8aed.png";